export const environment = {
  production: true,
  apiUrl: 'https://pension-calculator.pksgs.dev.eng.c-alm.ch'
};
